import React from 'react';
import {Box, useMediaQuery, useTheme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';

import {Buttons, Icon, Typography, Link} from 'components';
import clsx from 'clsx';
import {useUser} from 'hooks';
import {sendTag} from 'store/Tags';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        borderRadius: 8,
        padding: theme.spacing(1, 2)
    },
    wrapperRed: {
        background: '#FDF8F6',
        border: `solid 1px ${theme.palette.warningDark}`
    },
    wrapperBlue: {
        background: theme.palette.pale,
        border: `solid 1px ${theme.palette.blue}`
    },
    icon: {
        marginRight: theme.spacing(2),
        marginTop: 3
    },
    iconRed: {
        color: theme.palette.warningDark
    },
    iconBlue: {
        color: theme.palette.blue
    },
    button: {
        textAlign: 'left',
        borderRadius: 0
    },
    modal: {
        width: '100%',
        maxWidth: 700
    },
    link: {
        fontSize: 16,
        fontWeight: 700,
        cursor: 'pointer',
        color: theme.palette.blue,
        textDecoration: 'underline'
    },
    amount: {
        whiteSpace: 'nowrap',
        fontWeight: 700
    },
    buttonSSO: {
        padding: '8px !important',
        minWidth: '445px ! important'
    }
}));

function TapeAlertsEndOfService() {
    const classes = useStyles();
    const theme = useTheme();

    const {user} = useUser();

    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    const message = user?.messages?.alert_text_cutoff;

    const components = {
        bold: (
            <Typography
                component="span"
                semibold
            />
        ),
        sso: (
            <Buttons.SSO
                className={classes.buttonSSO}
                hash="open_sso_s2e"
                color="blueAlpha"
                next
                centerText
                disabled
            />
        ),
        linkTag: (
            <Typography
                component="a"
                size={16}
                color="blue"
                bold
                underlined
                onClick={() => {
                    sendTag(user, 'link::external_site::shares');
                }}
            />
        ),
        a: (
            <Typography
                component="a"
                size={16}
                color="blue"
                bold
                underlined
            />
        )
    };

    if (window.location.pathname !== '/epargne') return null;

    if (user?.disabled_scopes?.s2e?.length === 0) return null;

    return (
        <Box>
            <Box
                className={clsx(classes.wrapper, classes.wrapperRed)}
                mt={3}
            >
                <Box display="flex">
                    <Icon
                        className={clsx(classes.icon, classes.iconRed)}
                        name="axa-icons-danger"
                        size={24}
                        aria-hidden={true}
                    />
                    <Box
                        display="flex"
                        flexDirection={isMobile ? 'column' : 'row'}
                        justifyContent="space-between"
                        alignItems={isMobile ? 'flex-start' : 'center'}
                        minWidth="100%"
                        pr={4}
                    >
                        <Box>
                            <Typography
                                size={18}
                                color={'warningDark'}
                                semibold
                                localization={user.localization === 'en' ? message.en.title : message.fr.title}
                            />{' '}
                            <Typography
                                size={16}
                                key={`alert-ppv`}
                                color="dark"
                                gutterBottom={false}
                                localization={user.localization === 'en' ? message.en.message1 : message.fr.message1}
                                components={components}
                            />
                            <Typography
                                size={16}
                                key={`alert-ppv`}
                                color="dark"
                                gutterBottom={false}
                                localization={user.localization === 'en' ? message.en.message2 : message.fr.message2}
                                components={components}
                            />
                            <Typography
                                size={16}
                                key={`alert-ppv`}
                                color="dark"
                                gutterBottom={false}
                                localization={user.localization === 'en' ? message.en.message3 : message.fr.message3}
                                components={components}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default TapeAlertsEndOfService;
